import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import updatePageNumber from '~/helpers/pagination-helper';

var MdmLoader = function MdmLoader() {
  return import(
  /* webpackChunkName: "mdm-loader" */
  '~/components/atoms/Global/MdmLoader.vue');
};

export default {
  name: 'MdmInfiniteScroll',
  components: {
    MdmLoader: MdmLoader
  },
  props: {
    total: {
      type: Number,
      default: 3
    },
    from: {
      type: Number,
      default: 0
    },
    nextPage: {
      type: Number,
      default: 1
    },
    previousPage: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 40
    },
    progressMsg: {
      type: String,
      default: ''
    },
    buttonMsg: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    bottom: {
      type: Boolean,
      default: false
    },
    // I added this props so we can use this component with events
    // @on-previous-page
    // @on-next-page
    useEvents: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tracking: function tracking() {
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: 'Clic_plus de produits',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },
    hasMoreItems: function hasMoreItems() {
      return this.total - this.from > 0;
    },
    percent: function percent() {
      var percent = this.from < this.total ? Math.floor(this.from / this.total * 100) : 100;
      return {
        height: '5px',
        width: "".concat(percent, "%"),
        background: '#c4a181'
      };
    }
  },
  methods: _objectSpread({}, mapMutations({
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE'
  }), {
    previous: function previous() {
      if (this.useEvents) {
        this.$emit('on-previous-page', this.previousPage);
      } else {
        this.setPreviousPage(this.previousPage - 1);
        updatePageNumber(this.previousPage - 1);
      }
    },
    next: function next() {
      if (this.useEvents) {
        this.$emit('on-next-page', this.nextPage);
      } else {
        this.setNextPage(this.nextPage + 1);
        updatePageNumber(this.nextPage + 1);
      }
    }
  })
};